import lozad from 'lozad';

const observer = lozad('.lozad', {
  rootMargin: '60% 0px',
  threshold: 0.1,
  loaded: function(el) {
    el.classList.add( 'loaded' )
  }
});
observer.observe();